/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/conponents/ShopInfo/index.tsx
 * @Description: 商品详情页店铺信息
 */
import React, { useContext } from 'react';
import { UserContext } from 'libs/contexts';
import styles from './index.module.scss';
import { cls } from 'reactutils';

const PAGE_TYPE_ENUM = {
  NORMAL: 1, // 普通店铺
  PRO: 2, // 高级店铺
};
const ShopPopover = ({ shop }) => {
  const userInfo = useContext(UserContext) || ({} as UserInfo);
  const score = parseFloat(shop?.score) / 20;
  const shopHref =
    shop?.pageType === PAGE_TYPE_ENUM.PRO
      ? `/pages/shop/pro/index/${shop?.sysNo}`
      : `/shop/index/${shop?.sysNo}`;
  return (
    <div className={styles.shop_info}>
      <div className={styles.shop_head}>
        <span>{shop?.name}</span>
        {userInfo && (
          <div className={styles.shop_auth_box}>
            <i className="iconfont icon-auth" />
          </div>
        )}
      </div>
      <div className={styles.shop_body}>
        <div className={styles.shop_title}>店铺评分</div>
        {userInfo ? (
          shop?.score ? (
            <>
              <div className={styles.shop_score}>{shop?.score}</div>
              <div className={styles.shop_star_wrap}>
                {[0, 1, 2, 3, 4].map((item, i) =>
                  score - item >= 1 ? (
                    <img src="/assets/imgs/product/star/star.png" alt="" key={i} />
                  ) : score - item > 0 ? (
                    <img src="/assets/imgs/product/star/star-half.png" alt="" key={i} />
                  ) : score - item <= 0 ? (
                    <img src="/assets/imgs/product/star/star-gray.png" alt="" key={i} />
                  ) : (
                    ''
                  ),
                )}
              </div>
            </>
          ) : (
            <>
              <div className={styles.shop_no_score_star_wrap}>
                <i className="iconfont icon-no-star" />
              </div>
              <div className={styles.shop_no_score_tip}>暂无评分</div>
            </>
          )
        ) : (
          <>
            <div className={styles.shop_lock}>
              <i className="iconfont icon-lock1" />
            </div>
            <div className={styles.shop_login_tip}>登录后可见</div>
          </>
        )}
        <div className={styles.shop_desc}>
          <span>主营：</span>
          {shop?.mainBusiness}
        </div>
        <p className={styles.info}>
          <span>店铺客服：</span>
          {shop?.serviceHotline}
        </p>
        <p className={styles.info}>
          <span>服务时间：</span>
          {shop?.serviceHours}
        </p>
      </div>
      <div className={styles.shop_link_box}>
        <a className={styles.shop_link} rel="noreferrer" onClick={() => {
          window.open(shopHref)
        }}>
          进入店铺
        </a>
      </div>
    </div>
  );
};
const ShopInfo = ({ shopData }) => {
  return (
    <div style={{ position: 'relative' }}>
      {shopData?.name && (
        <div className={styles.shop_box}>
          <div className={styles.shop_sign}>
            <i className={cls('iconfont icon-store', styles.shop_icon)} />
            <span className={styles.shop_name}>{shopData.name}</span>
          </div>
          <ShopPopover shop={shopData} />
        </div>
      )}
    </div>
  );
};
export default ShopInfo;
